(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function applyRevealClass() {
    var main = document.querySelector('main[data-template="index"]');
    if (!main) return;

    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    sections.forEach(function (el) {
      el.classList.add('scroll-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRevealClass);
  } else {
    applyRevealClass();
  }
})();
